import { compose } from 'redux';
import { connect } from 'react-redux';
import selectors from '../../../../rootSelectors';
import RCTFluencyModelView from './RCTFluencyModelView';
import { goToPractice } from '../../../../common/navigation/navigationActions';
import { RCT, FLUENCY } from '../../../../constants/measure';
import { stopAudio, narrateStart, narrateReset } from '../../../../common/audio/audioActions';
import {
    hideQuestion, showSegment, hideSegment, fetchRctFluCompContent,
} from '../../../rctActions';
import {
    unmountScreen, blockScreen, unblockScreen, disableDownButton, dehighlightDownButton,
    greyOutScreen, colorInScreen,
} from '../../../../common/screen/screenActions';
import { MODEL } from '../../../../constants/assessmentItemType';
import {
    showNextElementOnDownButtonClick, showNextSegment, showNavigationButton,
    narrateDirectionsScript, narrateModelScript, narrateQuestionScript,
} from './RCTFluencyModelActions';
import { selectPossibleResponse, resetQuestionsAndTimeTrackingState } from '../../../../common/questions/questionsActions';
import AvatarView from '../../../../common/avatar/avatarView';
import withAvatar from '../../../../common/avatar/withAvatar';

const mapStateToProps = (state) => ({
    isScreenBlocked: selectors.getIsScreenBlocked(state),
    isNextButtonActive: selectors.getIsNextButtonActive(state),
    isDownButtonEnabled: selectors.getIsDownButtonEnabled(state),
    isDownButtonHighlighted: selectors.getIsDownButtonHighlighted(state),
    isDataFetched: selectors.getIsRCTFluencyDataFetched(state),
    segments: selectors.getSegments(state, MODEL),
    question: selectors.getCurrentQuestion(state, MODEL),
    passageTitle: selectors.getPassageTitle(state, MODEL),
    activeSegmentIndex: selectors.getActiveSegmentIndex(state),
    isQuestionVisible: selectors.getIsQuestionVisible(state),
    isSegmentVisible: selectors.getIsSegmentVisible(state),
    selectedResponse: selectors.getSelectedIndex(state),
    isGreyedOut: selectors.getIsScreenGreyedOut(state),
});

const mapDispatchToProps = (dispatch) => ({
    fetchContent: () => {
        dispatch(fetchRctFluCompContent());
    },
    initializePassage: () => {
        dispatch(greyOutScreen());
        dispatch(showSegment(0));
    },
    narrateScreen: () => {
        dispatch(blockScreen());
        dispatch(narrateStart());
        return dispatch(narrateDirectionsScript())
            .then(() => {
                dispatch(colorInScreen());
                return dispatch(narrateModelScript());
            }).then(() => {
                dispatch(unblockScreen());
            });
    },
    onResponseSelected: (index) => {
        dispatch(blockScreen());
        dispatch(selectPossibleResponse(index));
        dispatch(hideQuestion());
    },
    onPopupQuestionHide: () => {
        dispatch(resetQuestionsAndTimeTrackingState());
        dispatch(showNextSegment());
    },
    onSegmentShow: () => {
        dispatch(showNavigationButton());
    },
    onDownButtonClick: () => {
        dispatch(blockScreen());
        dispatch(dehighlightDownButton());
        dispatch(disableDownButton());
        dispatch(hideSegment());
        dispatch(showNextElementOnDownButtonClick());
        return dispatch(narrateQuestionScript())
            .then(() => {
                dispatch(unblockScreen());
            });
    },
    onOkButtonSelected: () => {
        dispatch(goToPractice(RCT, FLUENCY));
    },
    cleanup: () => {
        dispatch(stopAudio());
        dispatch(narrateReset());
        dispatch(resetQuestionsAndTimeTrackingState());
        dispatch(unmountScreen());
    },
});

const avatarMapStateToProps = () => ({
    position: AvatarView.Position.MIDDLE_LEFT,
});

const RCTFluencyModelContainer = compose(
    connect(mapStateToProps, mapDispatchToProps),
    withAvatar(avatarMapStateToProps),
)(RCTFluencyModelView);

export default RCTFluencyModelContainer;
